import { AfterViewInit, Component, ElementRef, Inject, Input, OnChanges, PLATFORM_ID, SimpleChanges, ViewChild } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Activity } from '../../core/dto/activity.dtos';

@Component({
    selector: 'app-products-carousel',
    templateUrl: './products-carousel.component.html',
    styleUrls: ['./products-carousel.component.scss']
})
export class ProductsCarouselComponent implements AfterViewInit, OnChanges {

    breakpoints = {
        320: { slidesPerView: 1, spaceBetween: 20 },
        480: { slidesPerView: 1, spaceBetween: 20 },
        640: { slidesPerView: 2, spaceBetween: 16 },
        990: { slidesPerView: 2, spaceBetween: 20 },
        1300: { slidesPerView: 3, spaceBetween: 10 },
    };

    @Input() products: Activity[] = [];
    @ViewChild('swiperContainer') swiperRef?: ElementRef<any>;

    private viewReady = false;

    constructor(@Inject(PLATFORM_ID) private readonly platformId: object) {}

    ngAfterViewInit(): void {
        this.viewReady = true;
        this.initSwiper();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['products'] && this.viewReady) this.initSwiper();
    }

    /**
     * Inicialización manual (init="false"): los productos ahora llegan desde el SSR
     * y el swiper se montaba antes de recibir los breakpoints → 1 card gigante.
     */
    private initSwiper(): void {
        if (!isPlatformBrowser(this.platformId) || !this.products?.length) return;
        Promise.resolve().then(() => {
            const el = this.swiperRef?.nativeElement;
            if (!el) return;
            try { el.swiper?.destroy?.(true, true); } catch { /* ignore */ }
            Object.assign(el, { slidesPerView: 1, spaceBetween: 32, loop: true, breakpoints: this.breakpoints });
            try { el.initialize(); } catch { try { el.swiper?.update?.(); } catch { /* ignore */ } }
        });
    }

    trackByFn(index: number, product: object) {
        return product;
    }
}
